<section
  role="dialog"
  aria-modal="true"
  *ngIf="confirmDialog"
  aria-labelledby="modal-title"
  class="inset-0 z-10 fixed overflow-y-auto"
>
  <div class="flex flex-col h-full text-center p-4 items-center justify-center">
    <div
      aria-hidden="true"
      class="bg-gray-500 bg-opacity-75 inset-0 transition-opacity fixed"
    ></div>

    <div
      class="bg-white rounded-lg shadow-xl text-left w-full transform transition-all overflow-hidden sm:max-w-screen-sm sm:my-8"
    >

      <section class="p-8">
        <div class="text-center p-4">{{confirmationText}}</div>

        <nav class="grid pt-4 gap-4 grid-cols-2">
          <app-button-primary
          (click)="confirmResponse(false)" [outline]="true">
            Cancel
          </app-button-primary>

          <app-button-primary
          (click)="confirmResponse(true)">
            Continue
          </app-button-primary>
        </nav>
      </section>
    </div>
  </div>
</section>
